<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e851430" style="color: #82a339"><b>ROASTED EGGPLANT DIP WITH HERBS</b></p>
<p class="ext" id="d7e852230"><b><i>The fresh flavors of lemon and mint are a perfect match for the baked eggplant in this Mediterranean-style dip.</i></b></p>
<p class="h4" id="d7e853230" style="color: #496210"><b>Prep: 15 minutes plus cooling and draining Roast: 1 hour</b></p>
<p class="ul" id="d7e854130">2 small eggplants (1 pound each)</p>
<p class="ul" id="d7e854430">2 garlic cloves, thinly sliced</p>
<p class="ul" id="d7e854730">2 tablespoons olive oil</p>
<p class="ul" id="d7e855030">4 teaspoons fresh lemon juice</p>
<p class="ul" id="d7e855330">1 teaspoon salt</p>
<p class="ul" id="d7e855630">¼ teaspoon ground black pepper</p>
<p class="ul" id="d7e856630">2 tablespoons chopped fresh parsley</p>
<p class="ul" id="d7e856930">2 tablespoons chopped fresh mint <br/> toasted pita bread wedges</p>
<p class="pub" id="d7e857730" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Preheat oven to 400°F. With knife, cut slits all over eggplants; insert garlic slices in slits. Place eggplants in jelly-roll pan and roast until collapsed and tender, about 1 hour.</p>
<p class="ser"><img alt="9781618371621_0030_002" src="Images/9781618371621_0030_002.jpg" style="max-width:100%;"/></p>
<p class="pub" id="d7e860930"><span style="color: #c15b49"><b>2.</b></span> When cool enough to handle, cut eggplants in half. Scoop out flesh and place in colander set over bowl; discard skin. Let drain 10 minutes.</p>
<p class="pub" id="d7e863430"><span style="color: #c15b49"><b>3.</b></span> Transfer eggplant to food processor with knife blade attached. Add oil, lemon juice, salt, and pepper; pulse to coarsely chop. Add parsley and mint, pulsing to combine. Spoon into bowl; cover and refrigerate up to 4 hours. Serve with toasted pita bread wedges. Makes about 2 cups.</p>
<p class="ntx" id="d7e866230">Each tablespoon: About 14 calories, 0g protein, 2g carbohydrate, 1g total fat (0g saturated), 0mg cholesterol, 74mg sodium.</p>
<p class="h4l" id="d7e867230" style="color: #496210"><b>BABA GANOUSH</b></p>
<p class="tx4" id="d7e867730">Prepare as directed above. Omit parsley and mint. Stir in <b>½ teaspoon ground cumin, ¼ cup tahini (sesame seed paste), </b>and <b>½ cup low-fat plain yogurt.</b></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c11_r1.vue?0cad5730